import Backend from 'App/Dataman-Backend';

const { apiUrlCompanies, apiUrlCompaniesStats, apiUrlCompanyImages, apiUrlCompanyCategories, apiUrlSuffix } =
  Backend.config;

export const COMPANIES_PATHS = {
  companies: apiUrlCompanies,
  stats: apiUrlCompaniesStats,
  images: apiUrlCompanyImages,
  categories: apiUrlCompanyCategories,
  suffix: apiUrlSuffix,
};
